import template from './rw-phone.html';

export default {
  template,
  controller: 'RwPhoneController',
  bindings: {
    phone: '<'
  },
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-phone/rw-phone-component.js